export default __webpack_public_path__ + "static/media/Product Details.540b07ba.svg";